import { ClaudeChatMock } from 'components/shared/bumperMcp/ClaudeMocks';
import { McpClientIcon } from 'components/shared/bumperMcp/McpClientIcon';
import { PromoCtaLink } from 'components/shared/bumperMcp/styled';
import { MCP_ROUTE } from 'routes/Mcp/constants';

import { CardRoot, CardText, CardTitle, ClaudeBadge } from './styledComponents';

export const BumperMcpCompactCard = () => (
  <CardRoot data-testid="bumper-mcp-compact-card">
    <div>
      <ClaudeBadge>
        <McpClientIcon client="claude" size={12} />
        Claude
      </ClaudeBadge>
      <CardTitle>Ask Claude for your vehicle report</CardTitle>
      <CardText>
        Connect once, then just ask Claude to pull VIN lookups, accident
        history, or market value.
      </CardText>
    </div>
    <PromoCtaLink
      compact
      to={MCP_ROUTE}
      data-testid="bumper-mcp-compact-card-cta"
    >
      Try it now
    </PromoCtaLink>
    <ClaudeChatMock compact />
  </CardRoot>
);
